import React__default from 'react';
import { S as StyledSvg, V as Variant } from './StyledSvg-Bc-aUfmk.js';

const Satisfied = ({
  disabled,
  checked
}) => /*#__PURE__*/React__default.createElement(StyledSvg, {
  $checked: checked,
  $disabled: disabled,
  $variant: Variant.SATISFIED,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("circle", {
  cx: "15",
  cy: "15",
  r: "15"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 2C7.8203 2 2 7.8203 2 15C2 22.1797 7.8203 28 15 28C22.1797 28 28 22.1797 28 15C28 7.8203 22.1797 2 15 2ZM0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.7105 19.2963C21.0991 19.6887 21.0961 20.3218 20.7037 20.7105C19.3684 22.0331 17.2811 23 15 23C12.7189 23 10.6317 22.0331 9.29629 20.7105C8.9039 20.3218 8.90087 19.6887 9.28952 19.2963C9.67817 18.9039 10.3113 18.9009 10.7037 19.2895C11.676 20.2526 13.2619 21 15 21C16.7381 21 18.324 20.2526 19.2963 19.2895C19.6887 18.9009 20.3218 18.9039 20.7105 19.2963Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12 11C12 12.1046 11.1046 13 10 13C8.89543 13 8 12.1046 8 11C8 9.89543 8.89543 9 10 9C11.1046 9 12 9.89543 12 11Z"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 13C11.1046 13 12 12.1046 12 11C12 9.89543 11.1046 9 10 9C8.89543 9 8 9.89543 8 11C8 12.1046 8.89543 13 10 13Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M22 11C22 12.1046 21.1046 13 20 13C18.8954 13 18 12.1046 18 11C18 9.89543 18.8954 9 20 9C21.1046 9 22 9.89543 22 11Z"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 13C21.1046 13 22 12.1046 22 11C22 9.89543 21.1046 9 20 9C18.8954 9 18 9.89543 18 11C18 12.1046 18.8954 13 20 13Z"
}));

export { Satisfied as S };
//# sourceMappingURL=Satisfied-CP-kFmO2.js.map
